<div class="desktop-layout">
    <div class="main-content">
        <app-map-desktop class="map-container" [sidebarIsOpen]="sidebarIsOpen"></app-map-desktop>
        <app-my-account></app-my-account>
        <app-layers></app-layers>
        <app-about></app-about>
        <app-legend [sidebarIsOpen]="sidebarIsOpen"></app-legend>
        <app-search [sidebarIsOpen]="sidebarIsOpen"></app-search>
        <app-scenario [selectedDate]="selectedDate" [sidebarIsOpen]="sidebarIsOpen"></app-scenario>
        <app-pref-position></app-pref-position>
    </div>
    <app-footer></app-footer>
</div>